import { Injectable } from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {FieldsService} from "./fields.service";
import 'rxjs/add/operator/take';

@Injectable()
export class PsusService {

  constructor(private db: AngularFireDatabase) { }

  addPsu(psuId: number, dbPath: string, description: string, defaultPower: number, power: number, overboost: number,
         installationDate: string, soll: number, ist: number, serialNr: string, burnTime: number, powerConsumption,
         outVoltage12: number, outVoltage34: number, current: number, inputVoltage: number, powerOnValue: number) {
    let psu = {
      "description": description,
      "defaultPower": defaultPower,
      "power": power,
      "overboost": overboost,
      "installationDate": installationDate,
      "soll": soll,
      "ist": ist,
      "serialNr": serialNr,
      "burnTime": burnTime,
      "powerConsumption": powerConsumption,
      "outVoltage12": outVoltage12,
      "outVoltage34": outVoltage34,
      "current": current,
      "inputVoltage": inputVoltage,
      "powerOnValue": powerOnValue
    };

    let path = dbPath + '/' + psuId;
    //console.log("dbPath in addPsu(): " + path);

    if ( psu.powerOnValue === -1 ) {
      delete psu.powerOnValue;
    }

    const psuRef = this.db.object(path).snapshotChanges().take(1);
    psuRef.subscribe(data => {
      if(data.key === psuId.toString()) {
        alert('PSU bestaat al! Kan geen PSU ' + psuId + ' toevoegen.');
      } else {
        this.db.database.ref(dbPath).child(psuId.toString()).set(psu);
      }
    });
  }

  updatePsu(dbPath: string, description: string, defaultPower: number, power: number, overboost: number,
            installationDate: string, soll: number, ist: number) {
      let psu = {
        "description": description,
        "defaultPower": defaultPower,
        "power": power,
        "overboost": overboost,
        "installationDate": installationDate,
        "soll": soll,
        "ist": ist
      };

      this.db.object(FieldsService.fieldsPath + dbPath).update(psu);
  }

  updatePsuIst(dbPath: string, ist: number) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/ist").set(ist);
  }

  updatePsuDefaultPower(dbPath: string, defaultPower: number) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/defaultPower").set(Number(defaultPower));
  }

  updatePsuPower(dbPath: string, power: number) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/power").set(power);
  }

  updatePsuOverboost(dbPath: string, overboost: number) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/overboost").set(overboost);
  }

  updatePsuSerialNr(dbPath: string, serialNr: string) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/serialNr").set(serialNr);
  }

  updatePsuBurnTime(dbPath: string, burnTime: number) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/burnTime").set(burnTime);
  }

  updatePsuPowerConsumption(dbPath: string, powerConsumption: number) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/powerConsumption").set(powerConsumption);
  }

  updateDateOfInstallation(dbPath: string, date: string) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/installationDate").set(date);
  }

  updatePsuDescription(dbPath: string, date: string) {
    this.db.object(FieldsService.fieldsPath + dbPath + "/description").set(date);
  }
}
